import { useEffect, useState } from 'react';
import { AppVersions, getAppVersions, loadAppVersions } from 'utils/version';

/**
 * Both versions for display. Starts from the synchronous snapshot (bundle
 * version only) and fills in the native half once Capacitor answers, so a
 * panel renders immediately instead of waiting on a plugin call.
 */
export const useAppVersions = (): AppVersions => {
  const [versions, setVersions] = useState<AppVersions>(getAppVersions);

  useEffect(() => {
    let active = true;
    // .catch is belt-and-braces rather than a live path: loadAppVersions
    // swallows a failed native read and resolves with the bundle-only shape,
    // so this cannot currently reject. Kept so a future change in there cannot
    // turn into an unhandled rejection at boot.
    loadAppVersions()
      .then((next) => {
        if (active) setVersions(next);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return versions;
};

export default useAppVersions;
